import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { IPatientHistoric } from "@comunicare/comunicare-interfaces";
import * as moment from "moment";

export class PatientHistoricDialogDataSource extends MatTableDataSourceExtended<IPatientHistoric> {
  sortingDataAccessor = (data: IPatientHistoric, sortHeaderId: string) => {
    switch (sortHeaderId) {
      case "date":
        return moment(data.date).unix();
      case "modified":
        return moment(data.modified).unix();
      case "author":
        return data.author?.reference.toLowerCase();
      case "oldReason":
        return data.oldReason;
      case "newReason":
        return data.newReason;
      default:
        return "";
    }
  };

  constructor() {
    super();
  }

  public loadData(data: IPatientHistoric[]) {
    this.data = data;
  }
}
